import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'Features', id: 'solution' },
    { label: "Who It's For", id: 'who-it-is-for' },
    { label: 'Benefits', id: 'benefits' },
    { label: 'Pricing', id: 'pricing' },
    { label: 'For Seniors', id: 'elderly-dashboard' },
    { label: 'Emergency', id: 'emergency' },
    { label: 'Discharge Companion', id: 'discharge-companion' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center gap-2 cursor-pointer">
            <img
              alt="CareBridge"
              className="h-10 w-auto object-contain"
              src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/ce833f012c3f23716ee4b56643f21003.png"
            />
          </button>
          <div className="hidden lg:flex items-center gap-5">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
            <a
              href="https://carebridge4elderly.base44.app"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-sm font-semibold bg-secondary-500 text-white px-5 py-2.5 rounded-full hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Join the App
            </a>
          </div>
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>
      {mobileOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-md border-t border-background-200 shadow-lg px-4 py-4 space-y-2">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="block w-full text-left text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2 cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://carebridge4elderly.base44.app"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="block w-full text-sm font-semibold bg-secondary-500 text-white px-5 py-2.5 rounded-full hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap mt-2 text-center"
          >
            Join the App
          </a>
        </div>
      )}
    </nav>
  );
}